import { selectClasses } from '@mui/material'
import { Theme } from '@mui/material/styles'

import { layout } from '../tokens.generated'
//
import { InputSelectIcon } from './CustomIcons'

// ----------------------------------------------------------------------
// A select is an input. The native one is an `<input>`-shaped element and
// takes the input geometry as it is. The non-native one renders its value in
// a `div` that MUI pins to `height: auto` two classes deep, so the control
// height is restated at that depth and the value is centred by the box: no
// block padding, no line-height arithmetic. A wrapped value (the chip stack
// of a multiple select) centres the same way.
//
// A locked select draws no chevron — see `components/EditableValue/
// EditableEnumValue.tsx` — so the room MUI keeps at the end of the value for
// an arrow is room for nothing, and it is given back here.
// ----------------------------------------------------------------------

export default function Select(theme: Theme) {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: InputSelectIcon,
      },
      styleOverrides: {
        select: {
          [`&.${selectClasses.select}`]: {
            height: layout.controlHeight,
            minHeight: 0,
            boxSizing: 'border-box' as const,
            display: 'flex',
            alignItems: 'center',
            paddingBlock: 0,
          },
          [`&.${selectClasses.select}.MuiInputBase-inputSizeSmall`]: {
            height: layout.controlHeightSmall,
          },
          // The arrow's room, given back when there is no arrow. MUI reserves
          // 32px at the end of an outlined select's value; a locked one puts
          // the lock in the adornment instead, so without this the value would
          // stop 32px short of a mark the locked field beside it stops right
          // next to — a second difference between the two, where the chevron
          // is supposed to be the only one.
          //
          // Doubled rather than left to tie with MUI's own `&&&`: two rules of
          // equal weight are decided by source order, silently. The state is
          // read off the root's attribute, so an unlocked select is out of
          // reach of this rather than relying on it losing.
          '[data-availability="locked"] &&': {
            paddingRight: 0,
          },
        },
      },
    },
  }
}
